<mat-card>
  <mat-form-field appearance="outline">
    <mat-label>Notepad</mat-label>
    <textarea
      placeHolder="Notepad"
      [(ngModel)]="outputData" (keyup)="onInputChanged(outputData)"
      matInput
      cdkTextareaAutosize
      cdkAutosizeMinRows="5">
    </textarea>
  </mat-form-field>
  <div>
    <button mat-raised-button color="accent" *ngIf="outputData.length > 0" (click)="outputData=''">clear</button>
  </div>
</mat-card>
